import {useCallback, useContext, useState} from 'react'
import {useAuth} from "./auth.hook";
import {message} from "antd";
import {AuthContext} from "../context/AuthContext";
import {NO_BACKEND, notifyNetworkError} from "../config/runtime";

export const useHttp = ({def = undefined}) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const {logout, token} = useContext(AuthContext)

  const request = useCallback(async (url, method = 'GET', body = null, headers = {}) => {
    setLoading(true)
    try {
      if (body) {
        body = JSON.stringify(body)
        headers['Content-Type'] = 'application/json'
      }

      headers['Authorization'] = `Bearer ${token}`;

      const response = await fetch(url, {method, body, headers})
      const data = await response.json()

      /*if (!response.ok) {
        const err = `Ошибка связи с сервером:  + ${data.message || 'ошибка неизвестна'}`
        message.error(err)
        setError(err)
        return def
      } */

      if (response?.status === 401)
      {

        const err = `Сессия закрыта или нет доступа: ${data.message || 'причина неизвестна'}`
        notifyNetworkError(message, err)
        setError(err)

        if (!NO_BACKEND) logout();
        //window.location.reload(true);

        return def
      }

      if (!response.ok) {
        const err = `Ошибка связи с сервером: ${data.message || 'причина неизвестна'}`
        notifyNetworkError(message, err)
        setError(err)
        return def
      }

      setLoading(false)

      return data
    } catch (e) {
      setLoading(false)
      const err = `Ошибка связи с сервером: ${e.message || 'причина неизвестна'}`
      notifyNetworkError(message, err)
      setError(err)
      throw e
    }
  }, [])

  const clearError = useCallback(() => setError(null), [])

  return { loading, request, error, clearError }
}
